<!--
/**
* @name: List.vue
* @description: 客商管理列表页
* @author: 杨波
* @create: 2020/08/11 09:40:37
* @update: 2020/08/11 09:40:37
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input placeholder="请输入客商编码/名称" block clearable v-model="para.codeOrName"></k-input>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择审核状态" block clearable v-model="para.verifyStatus">
          <k-option v-for="item in verifyStatusList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择状态" block clearable v-model="para.status">
          <k-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="dataList" :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" v-if="dataList && dataList.length" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>

<script>
import {
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_PAGELIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_STATUS_UPDATE,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_VERIFY,
} from "@/assets/modules/apiList";
const initPara = () => ({
  codeOrName: "",
  status: "",
  verifyStatus: "",
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      isLoading: false,
      dataList: [],
      para: initPara(),
      statusList: [
        { label: "启用", value: 1 },
        { label: "停用", value: 2 },
      ],
      verifyStatusList: [
        { label: "待审核", value: 1 },
        { label: "已审核", value: 10 },
      ],
      total: 0,
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "客商编码",
          field: "customerCode",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "主数据编码",
          field: "mainCustomerCode",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => {
            let temp = row.mainCustomerCode ? row.mainCustomerCode : "--";
            return <div>{temp}</div>;
          },
        },
        {
          name: "客商名称",
          field: "name",
          style: {
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "状态",
          field: "",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => (
            <k-switch
              checked={row.status}
              readonly
              onClick={() => {
                this.onChangeStatus(row);
              }}
            />
          ),
        },
        {
          name: "审核状态",
          field: "",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => {
            let temp = "";
            for (let i = 0; i < this.verifyStatusList.length; i++) {
              if (row.verifyStatus == this.verifyStatusList[i].value) {
                temp = this.verifyStatusList[i].label;
                break;
              }
            }
            return (
              <div>
                <span>{temp}</span>
              </div>
            );
          },
        },
        {
          name: "操作",
          field: "action",
          style: { textAlign: "center", width: 60 },
          customRender: (row) => {
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEdit(row);
                }}
              >
                编辑
              </a>
            );
            const previewButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row);
                }}
              >
                查看
              </a>
            );
            const verifyButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onVerify(row);
                }}
              >
                审核
              </a>
            );
            const unverifyButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onUnVerify(row);
                }}
              >
                反审核
              </a>
            );
            if (row.verifyStatus == "1") {
              return (
                <div>
                  {previewButton}&#12288;{editButton}&#12288;{verifyButton}
                </div>
              );
            } else if (row.verifyStatus == "10") {
              return (
                <div>
                  {previewButton}&#12288;{unverifyButton}
                </div>
              );
            }
          },
        },
      ];
    },
    onChangeStatus(row) {
      let { id, status } = row;
      this.$dialog({
        title: "提示",
        content: `是否确认${row.status == "1" ? "停用" : "启用"}该客商？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_STATUS_UPDATE,
            para: { id, status: status == "1" ? 2 : 1 },
          })
            .then(() => {
              this.isLoading = false;
              this.getCustomerList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    getCustomerList() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_PAGELIST,
        para,
      }).then((res) => {
        this.dataList = res.pageList || [];
        this.total = res.total;
      });
    },
    onVerify(row) {
      let { tip } = this.$root;
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_VERIFY,
        para: { verifyStatus: 10, customerCode: [row.customerCode] },
      }).then((res) => {
        tip("审核成功");
        this.isLoading = false;
        this.getCustomerList();
      });
    },
    onUnVerify(row) {
      let { tip } = this.$root;
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_CUSTOMER_VERIFY,
        para: { verifyStatus: 1, customerCode: [row.customerCode] },
      }).then((res) => {
        tip("反审核成功");
        this.isLoading = false;
        this.getCustomerList();
      });
    },
    onEdit(row) {
      this.$controller.open({
        name: "custAdd",
        query: {
          refresh: new Date() - 0,
          code: row.customerCode,
          edit: 1,
        },
        title: "编辑客商信息",
      });
    },
    onView(row) {
      this.$controller.open({
        name: "custAdd",
        query: {
          refresh: new Date() - 0,
          code: row.customerCode,
          view: 1,
        },
        title: "查看客商信息",
      });
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getCustomerList();
    },
    onReset() {
      this.para = initPara();
      this.getCustomerList();
    },
    onChangePageIndex(p) {
      this.dataList = [];
      this.para.pageCurrent = p;
      this.getCustomerList();
    },
  },
  created() {
    this.getCustomerList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getCustomerList();
    next();
  },
};
</script>

<style lang="postcss" module="css"></style>
